// FAB position slots
interface IFabPosition {
    position: "fixed"
    bottom: number
    right: number
}
type TFabDispatcher = Record<number, IFabPosition>

const FAB_POSITION_NAV_BAR = {
    position: "fixed",
    bottom: 16,
    right: 16,
}
const FAB_POSITION_0: IFabPosition = {
    position: "fixed",
    bottom: 110,
    right: 5,
}
const FAB_POSITION_1: IFabPosition = {
    position: "fixed",
    bottom: 200,
    right: 5,
}
const FAB_POSITION_2: IFabPosition = {
    position: "fixed",
    bottom: 250,
    right: 5,
}
const FAB_POSITION_3: IFabPosition = {
    position: "fixed",
    bottom: 350,
    right: 5,
}
const FAB_POSITION_4: IFabPosition = {
    position: "fixed",
    bottom: 400,
    right: 5,
}
const FAB_POSITION_DISPATCHER: TFabDispatcher = {
    0: FAB_POSITION_0,
    1: FAB_POSITION_1,
    2: FAB_POSITION_2,
    3: FAB_POSITION_3,
    4: FAB_POSITION_4,
}

export { FAB_POSITION_NAV_BAR, FAB_POSITION_DISPATCHER }
